import SplashPage from 'src/pages/SplashPage'
import SearchMainPage, { searchMainPageLoader } from 'src/pages/SearchPage/SearchMainPage'
import SearchResultPage from 'src/pages/SearchPage/SearchResultPage'
import JoinOtpCertPage from 'src/pages/JoinPage/JoinOtpCertPage'
import BrandListPage, { brandListPageLoader } from 'src/pages/BrandListPage'
import CouponDetailPage, { couponDetailPageLoader } from 'src/pages/CouponDetailPage'
import CouponPaymentPage, { couponPaymentLoader } from 'src/pages/CouponPaymentPage'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import ErrorBoundaryPage from 'src/router/ErrorBoundaryPage'
import PageLayout from 'src/components/layout/PageLayout'
import { QueryCache, QueryClient } from '@tanstack/react-query'
import FreeCouponPage, { freeCouponPageLoader } from 'src/pages/FreeCouponPage'
import CancelCompletePage from 'src/pages/CancelPage/CancelCompletePage'
import Mypage from 'src/pages/Mypage'
import CouponPurchasePage, { couponPurchasePageLoader } from 'src/pages/CouponPurchasePage'
import ExternalResourcePage from 'src/pages/ExternalResourcePage'
import CancelPage from 'src/pages/CancelPage'
import FreeCouponDetailPage, {
  freeCouponDetailPageLoader,
} from 'src/pages/FreeCouponPage/FreeCouponDetailPage'
import Billgate from 'src/pages/Billgate'
import SamsungIsPay from 'src/pages/SamsungIsPay'
import BrandPage from 'src/pages/BrandPage'
import PurchaseHistoryDetailPage, {
  purchaseHistoryDetailPageLoader,
} from 'src/pages/PurchaseHistoryPage/PurchaseHistoryDetailPage'
import PurchaseHistoryPage from 'src/pages/PurchaseHistoryPage'
import CouponRefundPage, { couponRefundPageLoader } from 'src/pages/CouponRefundPage'
import NotifySettingsPage, { notifyPageLoader } from 'src/pages/NotifySettingPage'
import SelfRegCouponMainPage from 'src/pages/SelfRegCouponPage/SelfRegCouponMainPage'
import SelfRegCouponUpdatePage, {
  selfRegisterUpdatePageLoader,
} from 'src/pages/SelfRegCouponPage/SelfRegCouponUpdatePage'
import SelfRegCouponCreatePage from 'src/pages/SelfRegCouponPage/SelfRegCouponCreatePage'
import AlwaysDiscountCouponPage, {
  alwaysDiscountCouponPageLoader,
} from 'src/pages/AlwaysDiscounCouponPage'
import MainPage from 'src/pages/MainPage'
import MainPageLayout from 'src/components/layout/MainLayout/MainPageLayout'
import SearchPageLayout from 'src/pages/SearchPage/_components/SearchPageLayout'
import TermsPage from 'src/pages/Mypage/TermsPage'
import React from 'react'
import SystemNoticePage from 'src/pages/SystemNoticePage'
import IntroPage from 'src/pages/IntroPage'
import PaymentFinishPage from 'src/pages/PaymentFinishPage'
import CouponMapPage from 'src/pages/CouponMapPage'
import { handleDeviceDetect } from 'src/provider/ChannelContextProvider'
import PassPage from 'src/pages/PassPage'
import PassFinishPageView from 'src/pages/PassPage/PassFinishPage/view'
import PurchaseHistorySavePage, {
  purchaseHistorySavePageLoader,
} from 'src/pages/PurchaseHistoryPage/PurchaseHistorySavePage'
import EasyLoginSettingsPage, { easyLoginSetPageLoader } from 'src/pages/EasyLoginSettingPage'
import GiftPurchasePage, { giftPurchasePageLoader } from 'src/pages/GiftSendPage/GiftPurchasePage'
import GiftPaymentPage, { giftPaymentLoader } from 'src/pages/GiftPaymentPage'
import GiftedCouponPage from 'src/pages/GiftedCouponPage'
import GiftedCouponDetailPage, {
  giftedCouponDetailPageLoader,
} from 'src/pages/GiftedCouponPage/GiftedCouponDetailPage'
import GiftOnlySendPage, { giftOnlySendPageLoader } from 'src/pages/GiftSendPage/GiftOnlySendPage'
import GiftCardPage, { giftCardPageLoader } from 'src/pages/GiftCardPage'
import GiftHotDealPage, { giftHotDealPageLoader } from 'src/pages/GiftHotDealPage'
import GiftHotDealDetailPage, {
  giftHotDealDetailPageLoader,
} from 'src/pages/GiftHotDealPage/GiftHotDealDetailPage'
import GiftRefundPage, { giftRefundPageLoader } from 'src/pages/GiftRefundPage'
import DownloadCouponPage, { downloadCouponPageLoader } from 'src/pages/DownloadCouponPage'
import Danal from 'src/pages/Danal'
import JoinLinkPage from 'src/pages/JoinLinkPage'
import PreviewPage from 'src/pages/PreviewPage'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) =>
      query.meta?.errorMessage && console.warn(query.meta.errorMessage, error),
  }),
  defaultOptions: { queries: { staleTime: 1000 * 30 } },
})

// children[] 사용X / reason: meta데이터 활용
export const routes = [
  {
    // 스플래시
    path: 'splash',
    element: <SplashPage />,
    index: true,
  },
  {
    path: 'intro',
    element: <IntroPage />,
  },
  //검색 메인
  {
    path: 'search/main',
    loader: searchMainPageLoader(queryClient),
    element: <SearchPageLayout children={<SearchMainPage />} />,
    meta: { isFooter: true },
  },
  // 검색 결과
  {
    path: 'search/result/:search_word',
    element: <SearchPageLayout children={<SearchResultPage />} />,
    meta: { isFooter: true },
  },
  {
    // 핫딜 쿠폰 페이지
    path: 'main',
    element: <MainPageLayout children={<MainPage />} />,
    meta: {
      isHeader: { leftImg: 'text_logo', rightImg: 'search_user' },
      isFooter: true,
      isTopButton: '100px',
    },
  },
  {
    // 상시할인쿠폰 페이지
    path: 'always/:alwaysCategory',
    loader: alwaysDiscountCouponPageLoader(queryClient),
    element: <MainPageLayout children={<AlwaysDiscountCouponPage />} />,
    meta: {
      isHeader: { leftImg: 'text_logo', rightImg: 'search_user' },
      isFooter: true,
      isTopButton: '100px',
    },
  },
  {
    // 브랜드 리스트 노출 화면
    path: 'brand_list',
    element: <MainPageLayout children={<BrandListPage />} />,
    loader: brandListPageLoader(queryClient),
    meta: {
      isHeader: { leftImg: 'text_logo', rightImg: 'search_user' },
      isFooter: true,
      isTopButton: '100px',
    },
  },
  {
    // 브랜드별 상품리스트, status: 0(판매중),1(보유중),
    path: 'brand_list/:categoryNumber/:brandNumber/:status',
    element: <BrandPage />,
    meta: {
      isHeader: { leftImg: 'back', text: 'exception' },
      isFooter: true,
    },
  },
  {
    // 로그인/가입 (번호인증)
    path: 'join/cert',
    element: <JoinOtpCertPage />,
    meta: { isHeader: { leftImg: 'back', text: '휴대폰번호 인증' } },
  },
  // 마이페이지 메인
  {
    path: 'mypage',
    element: <Mypage />,
    meta: { isHeader: { leftImg: 'back', text: '마이페이지' } },
  },
  //결제, 구매하기
  {
    path: 'coupon/purchase/:couponType/:couponIdx/:couponNumber',
    element: <CouponPurchasePage />,
    loader: couponPurchasePageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '구매하기' } },
  },
  // 구매 내역
  {
    path: 'coupon/purchase_history',
    element: <PurchaseHistoryPage />,
    meta: {
      isHeader: { leftImg: 'back', text: '구매내역 ', rightBtn: 'gifted_coupon' },
      isTopButton: '10px',
    },
  },
  // 구매 내역 상세
  {
    path: 'coupon/purchase_history/:couponIdx/:idx/:couponStatus/:couponType/:couponNumber',
    element: <PurchaseHistoryDetailPage />,
    loader: purchaseHistoryDetailPageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '구매한 쿠폰 정보' }, isFooter: true },
  },
  // 구매 내역 저장
  {
    path: 'coupon/purchase_history/save',
    element: <PurchaseHistorySavePage />,
    loader: purchaseHistorySavePageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '구매 내역 저장' } },
  },
  // 환불 신청
  {
    path: 'coupon/refund_apply/:idx/:couponIdx/:couponNumber/:orderId/:orderDT',
    element: <CouponRefundPage />,
    loader: couponRefundPageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '쿠폰 환불 신청' } },
  },
  //선물 구매하기(결제)
  {
    path: 'gift/purchase/:couponType/:couponIdx/:couponNumber',
    element: <GiftPurchasePage />,
    loader: giftPurchasePageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '선물 구매하기' } },
  },
  //구매내역에서 선물
  {
    path: 'gift/send_purchased/:idx/:couponStatus/:couponNumber',
    element: <GiftOnlySendPage />,
    loader: giftOnlySendPageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '선물 발송' } },
  },
  // 선물한 쿠폰(선물 내역)
  {
    path: 'gift/gifted_coupon',
    element: <GiftedCouponPage />,
    meta: {
      isHeader: { leftImg: 'back', text: '선물한 쿠폰' },
      isTopButton: '10px',
    },
  },
  // 선물한 쿠폰(선물 내역) 상세
  {
    path: 'gift/gifted_coupon/:giftIdx',
    element: <GiftedCouponDetailPage />,
    loader: giftedCouponDetailPageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '선물한 쿠폰 상세' }, isFooter: true },
  },
  //혜택- 무료쿠폰
  {
    path: 'coupon/free_coupon',
    element: <FreeCouponPage />,
    loader: freeCouponPageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '혜택' } },
  },
  //혜택- 무료쿠폰 상세-사용
  {
    path: 'coupon/free_coupon/:free_coupon_Idx',
    element: <FreeCouponDetailPage />,
    loader: freeCouponDetailPageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '쿠폰 사용' }, isFooter: true },
  },
  // 직접 등록한 쿠폰 메인
  {
    path: 'coupon/self_register',
    element: <SelfRegCouponMainPage />,
    meta: { isHeader: { leftImg: 'back', text: '직접등록한 쿠폰' }, isTopButton: '78px' },
  },
  {
    path: 'coupon/self_register/create',
    element: <SelfRegCouponCreatePage />,
    meta: { isHeader: { leftImg: 'back', text: '직접쿠폰등록' } },
  },
  //직접 등록 쿠폰 상세보기 (수정)
  {
    path: 'coupon/self_register/update/:couponIdx',
    element: <SelfRegCouponUpdatePage />,
    loader: selfRegisterUpdatePageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '쿠폰 정보 수정' } },
  },
  // 알림 설정
  {
    path: 'setting/notify',
    element: <NotifySettingsPage />,
    loader: notifyPageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '알림설정' } },
  },
  //간편 비밀번호 설정
  {
    path: 'setting/easy_login',
    element: <EasyLoginSettingsPage />,
    loader: easyLoginSetPageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '간편 비밀번호 설정' } },
  },
  //서비스 해지
  {
    path: 'cancel',
    element: <CancelPage />,
    meta: { isHeader: { leftImg: 'back', text: '서비스해지' } },
  },
  //서비스 해지 완료
  {
    path: 'cancel/complete',
    element: <CancelCompletePage />,
    meta: { isHeader: { text: '해지 완료' } },
  },
  //이용약관
  {
    path: 'help_center/terms',
    element: <TermsPage />,
    meta: { isHeader: { leftImg: 'back', text: '이용약관' } },
  },
  // Qna
  {
    path: 'help_center/qna',
    element: <ExternalResourcePage urlSrc="/webview/qna" />,
    meta: { isHeader: { leftImg: 'back', text: '1:1 문의' } },
  },
  // 공지사항
  {
    path: 'help_center/notice',
    element: <ExternalResourcePage urlSrc="/webview/notice" />,
    meta: { isHeader: { leftImg: 'back', text: '공지사항' } },
  },
  // 자주 묻는 질문
  {
    path: 'help_center/faq',
    element: <ExternalResourcePage urlSrc="/webview/faq" />,
    meta: { isHeader: { leftImg: 'back', text: '자주 묻는 질문' } },
  },
  // 약관 : 서비스 이용약관
  {
    path: 'help_center/terms/service',
    element: <ExternalResourcePage urlSrc="/webview/terms/Service" />,
    meta: { isHeader: { leftImg: 'back', text: '서비스 이용약관' } },
  },
  // 사업자 정보
  {
    path: 'help_center/terms/business',
    element: <ExternalResourcePage urlSrc="/webview/terms/BusinessInfo" />,
    meta: { isHeader: { leftImg: 'back', text: '사업자 정보' } },
  },
  // 약관 : 마케팅 수신동의
  {
    path: 'help_center/terms/marketing',
    element: <ExternalResourcePage urlSrc="/webview/terms/Marketing" />,
    meta: { isHeader: { leftImg: 'back', text: '마케팅 정보 수신 동의' } },
  },
  // 약관 : 개인정보처리방침
  {
    path: 'help_center/terms/privacy_policy',
    element: <ExternalResourcePage urlSrc="/webview/terms/PrivacyPolicy" />,
    meta: { isHeader: { leftImg: 'back', text: '개인정보처리방침' } },
  },
  {
    // 쿠폰 상세 , couponType: 0: always, 1: hot / couponNumber
    // 문자 URL로 발송되는 주소이므로 변경시 서버파트에 문의가 필요함
    path: 'coupon/detail/:couponType/:couponIdx/:couponNumber',
    element: <CouponDetailPage />,
    loader: couponDetailPageLoader(queryClient),
    meta: { isHeader: { leftImg: 'back', text: '상품 상세정보' }, isFooter: true },
  },
  {
    path: 'map',
    element: <CouponMapPage />,
  },
  {
    // 쿠폰 결제 상태 ) server redirect paymentStatus Params: paymentStatus: payment_success, payment_fail,
    // payment_cancel, purchase_cancel, refund_complete
    path: 'coupon/:paymentStatus/:couponType/:exception_Idx/:couponNumber/:orderId',
    loader: couponPaymentLoader(queryClient),
    element: <CouponPaymentPage />,
  },
  {
    // 선물 결제 상태 ) server redirect paymentStatus Params: paymentStatus: payment_success, payment_fail,
    // payment_cancel, purchase_cancel, refund_complete
    path: 'gift/:paymentStatus/:couponType/:exception_Idx/:couponNumber/:orderId',
    loader: giftPaymentLoader(queryClient),
    element: <GiftPaymentPage />,
  },
  {
    // 제휴사페이지 가입자 전용 로그인 페이지
    path: 'join/link/:telecom',
    element: <JoinLinkPage />,
  },
  {
    // 메인화면 미리보기 페이지(비로그인 상태)
    path: 'preview/:pCode',
    element: <PreviewPage />,
    meta: {
      isFooter: true,
    },
  },

  // 시스템 공지사항 페이지
  { path: 'system_notice', element: <SystemNoticePage /> },
  // 에러 페이지
  { path: 'error/:cmdType/:errCode', element: <ErrorBoundaryPage /> },
]

const searchParams = new URLSearchParams(window.location.search)
const search_params = `?${searchParams.toString()}`
const { channel } = handleDeviceDetect()

export const router = createBrowserRouter([
  {
    path: channel,
    element: <PageLayout />,
    errorElement: <ErrorBoundaryPage />,
    children: [
      { path: '', element: <Navigate to={`/${channel}/splash/${search_params}`} replace={true} /> },
      ...routes,
    ],
  },
  { path: '*', element: <ErrorBoundaryPage /> },
  { path: '/', element: <Navigate to={`/${channel}/splash/${search_params}`} replace={true} /> },

  /////////payment) pay_channel: ios, aos //////////
  {
    //pay_channel: ios, aos 외부 payment 결제창 호출
    path: '/:pay_channel/billgate/call/:payMethod/:couponType/:couponIdx/:couponNumber/:orderId/:pNumber',
    element: <Billgate />,
  },
  {
    path: '/:pay_channel/danal/call',
    element: <Danal />,
  },
  {
    // 다날 삼성페이 ISPAY: Bridge/새창 → StartURL form POST
    path: '/:pay_channel/samsung/call',
    element: <SamsungIsPay />,
  },
  {
    //결제창 종료 후 리다이렉트 페이지
    path: '/:pay_channel/coupon/payment/finish/:couponType',
    element: <PaymentFinishPage />,
    errorElement: <ErrorBoundaryPage />,
  },
  {
    // PASS인증
    path: `/:pass_channel/pass/:passReqType/:passReqNum`,
    element: <PassPage />,
  },
  {
    // PASS인증 종료 후 리다이렉트 페이지
    path: `/:pass_channel/pass/finish`,
    element: <PassFinishPageView />,
    errorElement: <ErrorBoundaryPage />,
  },
  {
    // 문자로 보내지는 쿠폰 이미지 주소. 서버파트 요청 아니면 변경x
    // idx = purchaseIdx
    path: 'couponImage/:requestId/:idx',
    element: <DownloadCouponPage />,
    loader: downloadCouponPageLoader(queryClient),
  },
  {
    // 선물받기-분기(수신자)
    path: `/:gift_channel/giftcard/:requestId/:giftType/:giftIdx`,
    loader: giftCardPageLoader(queryClient),
    element: <GiftCardPage />,
    errorElement: <ErrorBoundaryPage />,
  },
  {
    // 선물받기-진행중핫딜(수신인에게 핫딜 홍보용)
    path: `/:gift_channel/giftcard/hot_deal`,
    loader: giftHotDealPageLoader(queryClient),
    element: <GiftHotDealPage />,
    errorElement: <ErrorBoundaryPage />,
  },
  {
    // 선물받기-핫딜 상세(수신인에게 핫딜 홍보용)
    path: `/:gift_channel/giftcard/hot_deal/:couponIdx`,
    loader: giftHotDealDetailPageLoader(queryClient),
    element: <GiftHotDealDetailPage />,
    errorElement: <ErrorBoundaryPage />,
  },
  {
    // 선물받은 쿠폰 환불
    path: `/:gift_channel/giftcard/refund_apply/:requestId/:giftType/:giftIdx`,
    loader: giftRefundPageLoader(queryClient),
    element: <GiftRefundPage />,
    errorElement: <ErrorBoundaryPage />,
  },
])
